import { Icon } from "./Icon.tsx";

/** A square (NetworkMap.tsx's storage marker shape) with a plus badge, same "shape + plus" convention as AddJunctionIcon. */
export function AddStorageIcon() {
  return (
    <Icon>
      <rect x="5" y="9" width="10" height="10" />
      <path d="M18 3v6M15 6h6" />
    </Icon>
  );
}
